import React from 'react'
import PropTypes from 'prop-types'
import { sharedT } from '../../helpers/i18n'

// Terminal load failure for a step or panel; `role="alert"` like the app's flash containers.

const ErrorState = ({ message, className = '' }) => (
  <div className={[ 'gl-err-msg', className ].filter(Boolean).join(' ')} role="alert">
    {message || sharedT('error')}
  </div>
)

ErrorState.propTypes = {
  message: PropTypes.string,
  className: PropTypes.string,
}

export default ErrorState
